import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const GAZELLE_LOGO = "https://customer-assets.emergentagent.com/job_security-ops-hub-10/artifacts/gm0w9z4f_FLAVIGON.png";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Instant check: if we have a cached session, show the app immediately
    if (location.state?.user) return true;
    const cached = sessionStorage.getItem('gz_auth');
    return cached === 'true' ? true : null;
  });

  useEffect(() => {
    if (location.state?.user) {
      sessionStorage.setItem('gz_auth', 'true');
      setIsAuthenticated(true);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`,
          { credentials: 'include' }
        );
        if (!response.ok) throw new Error('Not authenticated');
        sessionStorage.setItem('gz_auth', 'true');
        setIsAuthenticated(true);
      } catch {
        sessionStorage.removeItem('gz_auth');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center gap-6">
        <img src={GAZELLE_LOGO} alt="Gazelle Security" className="h-20 w-20 object-contain animate-pulse" />
        <div className="flex flex-col items-center gap-2">
          <div className="flex gap-1.5">
            <span className="w-2.5 h-2.5 bg-[#2563EB] rounded-full animate-bounce" style={{animationDelay: '0ms'}} />
            <span className="w-2.5 h-2.5 bg-[#2563EB] rounded-full animate-bounce" style={{animationDelay: '150ms'}} />
            <span className="w-2.5 h-2.5 bg-[#2563EB] rounded-full animate-bounce" style={{animationDelay: '300ms'}} />
          </div>
          <p className="text-[#64748B] text-sm">Connexion en cours...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
